import { queryClient } from "@/client";
import { CRMPlatform } from "@/enums/CRM.enum";
import { useMutation } from "@tanstack/react-query";

import { useCRMConnectionListStatusKey } from "@/hooks/api/list/crm/useCRMConnectionListStatus";
import useSalesyApiClient from "@/hooks/useSalesyApiClient";

type CreateCRMListConnection = {
  platform: CRMPlatform;
  listId: string;
};

export const useConnectListCRM = () => {
  const { apiClient } = useSalesyApiClient();

  const mutation = useMutation({
    mutationFn: ({ listId: id }: CreateCRMListConnection) => apiClient.lists.connectHubspot({ id }),
    onSuccess: (_, { listId }) => {
      queryClient.invalidateQueries({
        queryKey: useCRMConnectionListStatusKey(listId),
      });
    },
  });

  return {
    ...mutation,
    connectListToCRM: mutation.mutate,
  };
};
